module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2020-09-04 at 22.41.28.0e0cb550.jpeg";